var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcCotizacionContado(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "none"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13,4.38A8.62,8.62,0,1,0,21.62,13,8.62,8.62,0,0,0,13,4.38Zm0,16A7.38,7.38,0,1,1,20.38,13,7.39,7.39,0,0,1,13,20.38Z",
    fill: "#3b444e"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.62,12.36V10.24a1.51,1.51,0,0,1,.78.51.62.62,0,0,0,1-.72A2.83,2.83,0,0,0,13.62,9V8.48a.63.63,0,0,0-1.25,0V9a2.46,2.46,0,0,0-2.18,2.27,2.48,2.48,0,0,0,2.18,2.27v2.12a1.25,1.25,0,0,1-.92-.85.62.62,0,1,0-1.23.21,2.51,2.51,0,0,0,2.15,1.93v.47a.63.63,0,0,0,1.25,0V16.9a2.46,2.46,0,0,0,2.18-2.27A2.48,2.48,0,0,0,13.62,12.36Zm-2.18-1.14a1.16,1.16,0,0,1,.93-1v2A1.16,1.16,0,0,1,11.44,11.22Zm2.18,4.4v-2a1.16,1.16,0,0,1,.93,1A1.16,1.16,0,0,1,13.62,15.62Z",
    fill: "#3b444e"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcCotizacionContado);
export default __webpack_public_path__ + "static/media/ic_cotizacion_contado.3403d03cc93874d968174afcace34b2e.svg";
export { ForwardRef as ReactComponent };